var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-box",attrs:{"id":"left-box-content"}},[_c('HotNews'),_c('HotApp'),_c('HotAd'),_c('li',{staticClass:"left-box-bottom-helper",attrs:{"id":"left-box-bottom-helper"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }